import { PropsWithChildren } from 'react';

import { styled } from '@mui/material';

import { Box, tokens } from '@cast/design-system';
import type { BoxProps } from '@cast/design-system';

type Props = PropsWithChildren<{ topDivider?: boolean } & BoxProps>;

/** @deprecated Use `DrawerFooter` from `@cast/design-system` instead. */
export const DrawerFooter = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'topDivider',
  target: 'Drawer-Footer',
})<Props>(({ topDivider }) => ({
  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: 0,
  background: tokens.theme.bg.structural.surface,
  ...(topDivider && {
    borderTop: `1px solid ${tokens.theme.border.structural.neutral}`,
  }),
}));
